// Modules
import React from 'react';
import PropTypes from 'prop-types';
import { FieldArray, Field } from 'redux-form';

// Components
import { TextInput } from 'components/forms/form-elements';
import { SimpleReduxForm } from 'components/forms/form-structure';
import { RemoveButton } from 'components/widgets/buttons';

function RenderItems({ fields }) {
  return (
    <div className="simple-array-input-list">
      { fields.map((name, index) =>
        <div key={index} className="form-flex-row">
          <Field component={TextInput} name={name} />
          <span className="form-element remove-button" ><RemoveButton onClick={() => fields.remove(index)} /></span>
        </div>
      ) }
      <a onClick={() => fields.push('')}>Add Item</a>
    </div>
  );
}

RenderItems.propTypes = {
  fields: PropTypes.object
};

// Component
export default function SimpleArrayForm({ items, rowComponent, ...passed }) {
  const component = rowComponent || RenderItems;

  return (
    <SimpleReduxForm
      form="simpleArrayForm"
      initialValues={{ items }}
      {...passed}
    >
      <FieldArray component={component} name="items" />
    </SimpleReduxForm>
  );
}

SimpleArrayForm.propTypes = {
  items: PropTypes.array
};



// WEBPACK FOOTER //
// ./app/components/forms/simple-array-form.js